import styled from 'styled-components';

import {buttonReset, colors} from 'theme';

export const TotalRowsCount = styled.div`
    font-size: 14px;
    line-height: 24px;
    color: ${colors.textMuted};
`;

export const HeaderControls = styled.div`
    margin-bottom: 10px;
`;

export const SpinnerLayer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

export const ConfigBlock = styled.div`
    margin-bottom: 16px;

    > * {
        margin-bottom: 10px;
    }
`;

export const Placeholder = styled.div`
    padding: 16px 20px;
    background: ${colors.white};
    color: ${colors.textSecondary};
    margin: 10px 0;
    min-height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:first-of-type {
        margin-top: 0;
    }

    &:last-of-type {
        margin-bottom: 0;
    }
`;

export const EndMessage = styled.div`
    color: ${colors.textSecondary};
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ListHeader = styled.div<{alignRight?: boolean}>`
    display: flex;
    justify-content: ${(p) => (p.alignRight ? 'flex-end' : 'space-between')};
    align-items: center;
    margin-bottom: 10px;
`;

export const ExportButton = styled.button`
    ${buttonReset};
    color: ${colors.brandPrimary};
    text-decoration: none;
    max-width: 180px;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 5px;
    margin-left: 10px;
    font-weight: 700;
    font-size: 12px;
`;
